module.exports = __webpack_public_path__ + "img/become_content_provider_bg_mobile.16b62068.png";